import { StyledIconButton } from './Button.Styled'
import type { IconButtonProps } from './Button.Types'

export const IconButton = ({
  children,
  isDisabled = false,
  size = 'medium',
  variant = 'secondary',
  ...htmlProps
}: IconButtonProps) => {
  return (
    <StyledIconButton
      {...htmlProps}
      disabled={isDisabled}
      $size={size}
      $variant={variant}
    >
      {children}
    </StyledIconButton>
  )
}
